"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ProfileImage_1 = __importDefault(require("../ProfileImage/ProfileImage"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var getStateQuery_1 = __importDefault(require("../utils/getStateQuery"));
var ProfileHeadingElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 180px;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  margin: 0 0 80px;\n\n  ", "\n"], ["\n  width: 100%;\n  min-height: 180px;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  margin: 0 0 80px;\n\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var centeredBreakpoint = _a.centeredBreakpoint;
    return (0, getStateQuery_1.default)(centeredBreakpoint, "\n        min-height: 120px;\n      ");
});
var ProfilePageContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  max-width: ", ";\n  flex: 1 1 auto;\n  min-height: 180px;\n  height: 100%;\n  width: 100%;\n  padding: 2.4rem ", " 1rem;\n  margin: 0 auto;\n"], ["\n  position: relative;\n  max-width: ", ";\n  flex: 1 1 auto;\n  min-height: 180px;\n  height: 100%;\n  width: 100%;\n  padding: 2.4rem ", " 1rem;\n  margin: 0 auto;\n"])), b2c_theme_1.maxPageSize, b2c_theme_1.pageGutter);
var ProfileImageElement = (0, styled_components_1.default)(ProfileImage_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: ", ";\n  bottom: -62px;\n\n  ", "\n"], ["\n  position: absolute;\n  left: ", ";\n  bottom: -62px;\n\n  ", "\n"])), b2c_theme_1.pageGutter, function (_a) {
    var centeredBreakpoint = _a.centeredBreakpoint;
    return (0, getStateQuery_1.default)(centeredBreakpoint, "\n      left: calc(100% - (50% + 62px));\n      ");
});
var ProfileHeading = function (props) {
    var defaultProps = {
        centeredBreakpoint: false,
    };
    var _a = __assign(__assign({}, defaultProps), props), alt = _a.alt, centeredBreakpoint = _a.centeredBreakpoint, children = _a.children, _b = _a.color, color = _b === void 0 ? b2c_theme_1.colors.defaultHeadingColor : _b, text = _a.text, url = _a.url;
    return (react_1.default.createElement(ProfileHeadingElement, { centeredBreakpoint: centeredBreakpoint, color: color, "data-testid": "profile-heading-element" },
        react_1.default.createElement(ProfilePageContainer, null,
            children,
            (url || text) && (react_1.default.createElement(ProfileImageElement, { alt: alt, centeredBreakpoint: centeredBreakpoint, text: text, url: url })))));
};
exports.default = ProfileHeading;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ProfileHeading.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/ProfileHeading/ProfileHeading.js
// module id = 2569
// module chunks = 19